// extracted by mini-css-extract-plugin
module.exports = {"NoProviders":"NoProviders_NoProviders__JBAKE","Paragraph":"NoProviders_Paragraph__OWQx9"};